var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientdata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 494,
    height: 512,
    viewBox: "0 0 494 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.31 393.995C477.801 356.961 490.753 313.492 490.753 266.998C490.753 192.168 457.194 125.186 404.319 80.2461H87.183C34.308 125.186 0.749023 192.168 0.749023 266.998C0.749023 313.492 13.701 356.961 36.192 393.995H455.31Z",
    fill: "#B197E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.448 54.8359H66.3801C49.7771 54.8359 36.1921 68.4199 36.1921 85.0239V393.998C47.9801 413.407 62.3991 431.036 78.9361 446.419L207.302 137.965L155.448 54.8359Z",
    fill: "#4A3279"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.448 54.8359L163.612 108.65C163.612 108.65 165.541 114.17 170.384 119.308L370.582 137.965L372.945 54.8369L155.448 54.8359Z",
    fill: "#5B4982"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M417.81 317.186V227.534L344.523 195.293L357.828 317.186H417.81Z",
    fill: "#5B4982"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M387.623 54.8359H372.946C372.946 54.8359 338.379 77.6319 362.829 119.307L346.527 184.233L375.066 227.536C375.066 227.536 398.008 254.032 417.81 227.536V85.0229C417.81 68.4199 404.226 54.8359 387.623 54.8359Z",
    fill: "#6C618C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.001 0C210.501 0 197.001 13.5 197.001 30V33.586L227 51.064L257.001 33.585V30C257.001 13.5 243.501 0 227.001 0Z",
    fill: "#FFC242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M218.552 33.5859H152.225C141.879 33.5859 133.414 42.0509 133.414 52.3969V74.7749C133.414 85.1209 141.879 93.5859 152.225 93.5859H218.553L237.113 63.5859L218.552 33.5859Z",
    fill: "#FFC242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.487 33.5859H218.552C218.55 33.5869 207.302 40.1929 207.302 53.5859V73.5859C207.302 73.5859 207.441 89.3569 218.552 93.5859H282.487L298.779 58.0649L282.487 33.5859Z",
    fill: "#FEF156"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M320.589 74.7749V52.3969C320.589 42.0509 312.124 33.5859 301.778 33.5859H282.488C282.486 33.5869 271.238 40.1929 271.238 53.5859V73.5859C271.238 73.5859 271.377 89.3569 282.488 93.5859H301.778C312.124 93.5869 320.589 85.1209 320.589 74.7749Z",
    fill: "#FFFBB3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M190.315 127.961C182.597 127.961 175.15 124.88 169.663 119.305H91.174C84.444 119.305 78.937 124.812 78.937 131.542V446.416C102.866 468.675 131.257 486.192 162.613 497.508L264.197 213.649L190.315 127.961Z",
    fill: "#BBF0F9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M362.829 119.305H284.34C279.083 124.646 271.774 127.961 263.688 127.961H190.316C190.316 127.961 185.071 160.647 209.676 167.647L227 213.65L191.839 264.962C191.839 264.962 162.612 281.658 162.612 315.653V497.508C188.572 506.877 216.56 512 245.751 512C293.223 512 337.531 498.484 375.066 475.112V131.542C375.066 124.812 369.559 119.305 362.829 119.305Z",
    fill: "#E8F8FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M267.66 188.706C267.66 207.425 252.485 228.617 233.767 228.617C215.048 228.617 199.873 207.425 199.873 188.706C199.873 169.987 215.048 154.812 233.767 154.812C252.485 154.812 267.66 169.987 267.66 188.706Z",
    fill: "#FFC1A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M233.766 228.617C220.358 228.617 206.948 228.617 203.226 228.617C187.853 228.617 174.567 239.351 171.337 254.382L169.215 269.104C167.458 281.3 176.648 292.985 189.658 292.985H212.032L240.098 258.214L233.766 228.617Z",
    fill: "#5A02FC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M296.196 254.382C292.967 239.353 279.68 228.617 264.307 228.617C260.598 228.617 247.181 228.617 233.766 228.617C233.763 228.618 218.569 234.503 216.87 251.483C215.172 268.464 212.032 292.985 212.032 292.985C299.415 292.985 273.002 293.019 278.13 292.984C290.658 292.9 300.104 281.504 298.317 269.104L296.196 254.382Z",
    fill: "#6E2FE2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M263.688 137.961H190.315C168.821 137.961 151.335 120.475 151.335 98.9795V83.8125C151.335 78.2905 155.812 73.8125 161.335 73.8125C166.858 73.8125 171.335 78.2905 171.335 83.8125V98.9795C171.335 109.445 179.85 117.959 190.315 117.959H263.688C269.21 117.959 273.688 122.437 273.688 127.959C273.688 133.482 269.21 137.961 263.688 137.961Z",
    fill: "#A188F6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M245.751 73.5859H208.251C202.728 73.5859 198.251 69.1079 198.251 63.5859C198.251 58.0639 202.728 53.5859 208.251 53.5859H245.751C251.273 53.5859 255.751 58.0639 255.751 63.5859C255.751 69.1079 251.273 73.5859 245.751 73.5859Z",
    fill: "#FD8D3E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263.688 137.961C258.166 137.961 253.688 133.482 253.688 127.96C253.688 122.438 258.166 117.96 263.688 117.96C274.154 117.96 282.668 109.445 282.668 98.9805V83.8125C282.668 78.2905 287.146 73.8125 292.668 73.8125C298.19 73.8125 302.668 78.2905 302.668 83.8125V98.9795C302.668 120.475 285.182 137.961 263.688 137.961Z",
    fill: "#C5AEFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M375.228 292.621C332.573 302.493 300.779 340.723 300.779 386.38C300.779 439.53 343.865 482.616 397.015 482.616C406.089 482.616 414.868 481.358 423.191 479.011L442.815 384.577L375.228 292.621Z",
    fill: "#7A27FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M491.096 366.07L447.503 335.893L438.278 299.421C425.772 293.476 411.783 290.145 397.015 290.145C389.522 290.145 382.229 291.002 375.228 292.622C375.218 292.64 359.671 322.269 385.517 335.892L408.513 436.869C408.513 436.869 397.099 465.427 423.191 479.012C463.62 467.611 493.251 430.457 493.251 386.381C493.251 379.413 492.503 372.619 491.096 366.07Z",
    fill: "#6602FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M416.502 405.71C415.348 406.822 414.628 408.381 414.628 410.11V430.755C414.628 434.132 411.89 436.87 408.513 436.87H385.517C382.14 436.87 379.402 434.132 379.402 430.755V410.11C379.402 406.733 376.664 403.995 373.287 403.995H352.642C349.265 403.995 346.527 401.257 346.527 397.88V374.885C346.527 371.508 349.265 368.77 352.642 368.77H373.287C376.664 368.77 379.402 366.032 379.402 362.655V342.01C379.402 338.633 382.14 335.895 385.517 335.895H408.513C411.89 335.895 414.628 338.633 414.628 342.01V362.655C414.628 364.384 415.349 365.942 416.502 367.055L410.023 383.71L416.502 405.71Z",
    fill: "#BBF0F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M441.388 368.77H420.743C419.095 368.77 417.602 368.115 416.502 367.055C407.756 369.148 401.247 376.996 401.247 386.383C401.247 395.77 407.757 403.618 416.502 405.711C417.602 404.651 419.095 403.996 420.743 403.996H441.388C444.765 403.996 447.503 401.258 447.503 397.881V374.886C447.503 371.508 444.765 368.77 441.388 368.77Z",
    fill: "#E8F8FC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M491.096 366.071C484.754 336.554 464.878 312.066 438.278 299.422C433.214 306.932 428.813 318.631 434.812 333.168C443.144 353.355 463.846 375.35 491.096 366.071Z",
    fill: "#6B2FE2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 334,
    width: 32,
    height: 20,
    rx: 4,
    fill: "#9B7CCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 334,
    width: 123,
    height: 20,
    rx: 4,
    fill: "#E3C7FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 368,
    width: 32,
    height: 20,
    rx: 4,
    fill: "#9B7CCC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 368,
    width: 123,
    height: 20,
    rx: 4,
    fill: "#E3C7FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 402,
    width: 32,
    height: 20,
    rx: 4,
    fill: "#9B7CCC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 402,
    width: 123,
    height: 20,
    rx: 4,
    fill: "#E3C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientdata);
export default __webpack_public_path__ + "static/media/patientdata.b8d4d9399cd2cb936fa9b6a10f11384b.svg";
export { ForwardRef as ReactComponent };